export default __webpack_public_path__ + "268407fe8887245bc8f47fce6646494e.png";